import { useAuth } from '../../hooks/useAuth.js';

// Client-side role gate. Server-side enforcement is the source of truth
// (withAuth in the Worker) — this component just hides UI to prevent showing
// controls the user can't actually use.
//
// Keep in sync with cloud/workers/src/middleware/auth.js ROLE_HIERARCHY.
const ROLE_HIERARCHY = {
  org_ro:        1,
  org_operator:  2,
  org_admin:     3,
};

export default function RequireAuth({ role, children }) {
  const { role: userRole } = useAuth();

  const userLevel = ROLE_HIERARCHY[userRole] ?? 0;
  const requiredLevel = ROLE_HIERARCHY[role] ?? 0;

  if (userLevel >= requiredLevel) {
    return children;
  }

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-amber-200 bg-amber-50 p-8">
      <h2 className="mb-2 text-lg font-semibold text-amber-800">Forbidden</h2>
      <p className="max-w-md text-center text-sm text-amber-600">
        You do not have permission to view this page. This page requires the <strong>{role}</strong> role.
      </p>
    </div>
  );
}
